import { deleteApiGalaxyServer } from 'services';
import ApiClientManager from 'core/apiClient';
import { Realm } from 'types';
import { Tenant } from 'TenantModule/types';

export interface ForceCleanUpSubscriptionParams {
  realmId: Realm['realm_id'];
  tenant: Tenant['tenantName'];
}

export interface ForceCleanUpSubscriptionSuccessResponse {
  message?: string;
}

export interface ForceCleanUpSubscriptionErrorResponse {
  error: string;
  message: string;
  statusCode: number;
}

/**
 * Drops the databases and secrets left behind by a subscription realm whose
 * teardown stopped short — `destroyRealm` only removes realm resources for
 * sandboxes, so Retry Destroy alone is a no-op for subscriptions.
 *
 * Unlike every other realm call in this module, the endpoint takes no body and
 * no query params: it reads the target realm from the `x-realm-id` / `x-tenant`
 * request headers.
 */
export const forceCleanUpSubscriptionApi = ({
  params,
  token,
  config = {},
}: BaseApiParams<ForceCleanUpSubscriptionParams>) =>
  deleteApiGalaxyServer<undefined, ForceCleanUpSubscriptionSuccessResponse>(
    '/realm/forceCleanUpSubscription',
    undefined,
    {
      ...config,
      headers: {
        ...config?.headers,
        ...ApiClientManager.buildUrlHeaders({
          tenantName: params.tenant,
          realmId: params.realmId,
        }),
      },
    },
    token,
  );
